// extracted by mini-css-extract-plugin
export const background = "AuthTemplate-module--background--33EBs";
export const header = "AuthTemplate-module--header--Jxad6";